module.exports = __webpack_public_path__ + "static/img/ny-02-BOLG.a56c907a.jpg";